export default __webpack_public_path__ + "static/media/sign-in-background.5e6093f4.png";